import useSWR from 'swr';
import { ResponseWrapper } from '@tlx/astro-shared';
import { APIUrls } from '@Util/urls.ts';

export type SalaryPermissionDTO = {
    canAccessAnnualAccounts: boolean;
};

export const useSalaryPermission = (year: number) => {
    return useSWR<ResponseWrapper<SalaryPermissionDTO>>(APIUrls.SALARY_PERMISSION(year));
};
